import "./index.css"
import "./mobile.css";

function Button(props){
    return <div className="button-holder">
        <img alt="button" className="button" src="./images/UI/Button.png" onClick={props.functionToAdd}></img>
        <div onClick={props.functionToAdd}>{props.text}</div>
        </div>
}


export default Button